import { render, staticRenderFns } from "./PanoramaPage.vue?vue&type=template&id=3df239de&scoped=true&"
import script from "./PanoramaPage.vue?vue&type=script&lang=js&"
export * from "./PanoramaPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df239de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3df239de')) {
      api.createRecord('3df239de', component.options)
    } else {
      api.reload('3df239de', component.options)
    }
    module.hot.accept("./PanoramaPage.vue?vue&type=template&id=3df239de&scoped=true&", function () {
      api.rerender('3df239de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PanoramaPage.vue"
export default component.exports